<template>
  <img :height="height" :width="width" ref="image" :src="'/media/' + sizeUrl + '?' + date" class="img-fluid">
</template>
<script>

import { TweenMax } from 'gsap'

export default {
  name: 'MVMImage',
  props: {
    height: {
      type: Number
    },
    width: {
      type: Number
    },
    date: {
      type: Number
    },
    img: {
      type: Object,
      default: () => {}
    },
    sizeUrl: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      url: null,
      loaded: false
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      TweenMax.set(this.$refs.image, { opacity: 0 })

      if (this.$refs.image.complete) {
        this.fadeIn()
      } else {
        this.$refs.image.onload = () => {
          this.fadeIn()
        }
      }
    },

    fadeIn () {
      TweenMax.to(this.$refs.image, 1, { opacity: 1 })
    }
  }
}
</script>
